import { Box, Grid, MenuItem, TextField } from '@mui/material';
import { CodeSet } from '@src/constants/CodeSets';
import { UseFormRegister } from 'react-hook-form';

interface OrganisationFormValues {
  shortCode: string;
  name: string;
  codeSet: string;
}

interface OrganisationFormProps {
  formId: string;
  fieldClassName: string;
  register: UseFormRegister<OrganisationFormValues>;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  disableOrganisationId?: boolean;
}

function OrganisationForm({
  formId,
  fieldClassName,
  register,
  onSubmit,
  disableOrganisationId = false,
}: OrganisationFormProps) {
  return (
    <form id={formId} onSubmit={onSubmit}>
      <Box p={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              className={fieldClassName}
              {...register('name', { required: true })}
              required
              label="Organisation name"
              name="name"
              variant="outlined"
              InputLabelProps={
                disableOrganisationId ? { shrink: true } : undefined
              }
              inputProps={{ autoComplete: 'off' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              className={fieldClassName}
              {...register('shortCode', {
                required: 'Organisation short code is required',
              })}
              required
              InputLabelProps={
                disableOrganisationId ? { shrink: true } : undefined
              }
              label="Short code"
              disabled={disableOrganisationId}
              name="shortCode"
              variant="outlined"
              inputProps={{ autoComplete: 'off' }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              className={fieldClassName}
              {...register('codeSet', { required: true })}
              required
              label="Code set"
              name="codeSet"
              variant="outlined"
              InputLabelProps={
                disableOrganisationId ? { shrink: true } : undefined
              }
              inputProps={{ autoComplete: 'off' }}
              defaultValue={CodeSet.OPCS}>
              <MenuItem value={CodeSet.OPCS}>{CodeSet.OPCS}</MenuItem>
              <MenuItem value={CodeSet.CCSD}>{CodeSet.CCSD}</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}

export default OrganisationForm;
export type { OrganisationFormValues };
